<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #QuinielaEquipos
    v-layout(align-start='' justify-start='' row='' fill-height='')
      v-flex(xs12 md12 sm12)
        v-card(style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png' style='height: auto;width: 140px;')
        v-card(style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Equipos del Mundial

    v-layout(align-center='' justify-end='' row='' wrap='' style='margin-top:10px;margin-right:5px;gap:8px;')
      v-btn(style="background:#1a1a2e;border-radius:10px;" dark @click='abrirImportar' :loading='importando')
        v-icon(left small) mdi-cloud-download
        | Importar desde API Mundial
      v-btn(style="background:#ff6500;border-radius:10px;" @click='abrirCrear') + Nuevo Equipo

    v-layout(align-start='' justify-start='' row='' wrap='' style='margin-top:5px;')
      v-flex(xs12)
        v-data-table.elevation-1(:headers='headers' :items='resultados' :loading='loading')
          template(v-slot:items='props')
            td
              img(v-if='props.item.bandera_url' :src='props.item.bandera_url' style='height:30px;width:auto;border-radius:3px;')
              span(v-else) —
            td {{ props.item.codigo }}
            td {{ props.item.nombre }}
            td {{ props.item.grupo || '—' }}
            td
              v-chip(:color="props.item.activo ? 'green' : 'red'" dark small) {{ props.item.activo ? 'Activo' : 'Inactivo' }}
            td
              v-btn(icon small @click='abrirEditar(props.item)')
                v-icon(color='#ff6500') edit
              v-btn(icon small @click='eliminar(props.item._id)')
                v-icon(color='red') delete

  v-dialog(v-model='dialog' max-width='500px')
    v-card
      v-card-title(style='background:black;')
        span.white--text {{ editando ? 'Editar Equipo' : 'Nuevo Equipo' }}
      v-card-text(style='padding-top:20px;')
        v-text-field(outlined v-model='form.nombre' label='Nombre del equipo' dense)
        v-text-field(outlined v-model='form.codigo' label='Código (ej: VEN, ARG)' dense :disabled='editando')
        v-text-field(outlined v-model='form.grupo' label='Grupo (ej: A, B)' dense)
        v-text-field(outlined v-model='form.bandera_url' label='URL de la bandera' dense)
        v-checkbox(v-model='form.activo' label='Activo' color='#ff6500')
      v-card-actions
        v-spacer
        v-btn(text @click='dialog = false') Cancelar
        v-btn(style='background:#ff6500;' dark @click='guardar' :loading='guardando') Guardar

  //- Dialog importar
  v-dialog(v-model='dialogImportar' max-width='820px')
    v-card
      v-card-title(style='background:black;display:flex;align-items:center;justify-content:space-between;')
        span.white--text Equipos encontrados en la API ({{ equiposAPI.length }})
        v-btn(icon dark @click='dialogImportar=false')
          v-icon mdi-close
      v-card-text(style='padding:0;')
        div(v-if='loadingAPI' style='text-align:center;padding:40px;')
          v-progress-circular(indeterminate color='#ff6500')
          p.grey--text(style='margin-top:12px;') Cargando equipos...
        div(v-else)
          div(style='padding:12px 16px;background:#f5f5f5;display:flex;align-items:center;justify-content:space-between;')
            span(style='font-size:13px;color:#555;') {{ equiposSeleccionados.length }} seleccionados
            div(style='display:flex;gap:8px;')
              v-btn(small text @click='seleccionarTodos') Seleccionar todos
              v-btn(small text @click='equiposSeleccionados=[]') Limpiar
          div(style='max-height:440px;overflow-y:auto;')
            v-data-table(
              :headers='headersImport'
              :items='equiposAPI'
              hide-actions
              style='font-size:13px;'
            )
              template(v-slot:items='props')
                td
                  v-checkbox(
                    :input-value='equiposSeleccionados.includes(props.item.fifa_code)'
                    @change='toggleSeleccion(props.item.fifa_code)'
                    color='#ff6500'
                    hide-details
                  )
                td
                  img(:src='props.item.flag' style='height:24px;width:auto;border-radius:2px;')
                td {{ props.item.fifa_code }}
                td {{ props.item.name_en }}
                td
                  v-chip(small :color="props.item.yaExiste ? 'orange' : 'green'" dark)
                    | {{ props.item.yaExiste ? 'Ya existe' : 'Nuevo' }}
                td {{ props.item.groups }}
      v-card-actions(style='padding:12px 16px;')
        span(style='font-size:12px;color:#999;') Los equipos marcados como "Ya existe" se actualizarán
        v-spacer
        v-btn(text @click='dialogImportar=false') Cancelar
        v-btn(style='background:#ff6500;' dark @click='confirmarImportar' :loading='guardandoImport' :disabled='equiposSeleccionados.length===0')
          | Importar {{ equiposSeleccionados.length }} equipo{{ equiposSeleccionados.length !== 1 ? 's' : '' }}

  v-dialog(v-model='dialog4' persistent max-width='400px')
    v-container(style='max-width:400px;background:#f1f2f1;')
      div(style='margin-top:20px;')
        v-layout(align-start='' justify-center='' row='' wrap='')
          v-flex(xs12)
            v-card-title.justify-center
              h4.black--text Esperando Respuesta del Servidor...
          v-flex(xs12)
            div(style='display:flex;justify-content:center;')
              img(src='../assets/waiting.gif' height='150')
</template>

<script>
import Api from '@/services/methods'
export default {
  name: 'QuinielaEquipos',
  data: () => ({
    resultados: [],
    loading: false,
    dialog: false,
    dialog4: false,
    dialogImportar: false,
    editando: false,
    guardando: false,
    importando: false,
    loadingAPI: false,
    guardandoImport: false,
    equiposAPI: [],
    equiposSeleccionados: [],
    form: { nombre: '', codigo: '', grupo: '', bandera_url: '', activo: true },
    defaultForm: { nombre: '', codigo: '', grupo: '', bandera_url: '', activo: true },
    headersImport: [
      { text: '', sortable: false },
      { text: 'Bandera', sortable: false },
      { text: 'Código', value: 'fifa_code' },
      { text: 'Nombre', value: 'name_en' },
      { text: 'Estado', sortable: false },
      { text: 'Grupo', value: 'groups' }
    ],
    headers: [
      { text: 'Bandera', value: 'bandera_url', sortable: false },
      { text: 'Código', value: 'codigo' },
      { text: 'Nombre', value: 'nombre' },
      { text: 'Grupo', value: 'grupo' },
      { text: 'Estado', value: 'activo' },
      { text: 'Acciones', sortable: false }
    ]
  }),
  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.loading = true
      Api.get('quiniela/equipos').then(res => {
        this.resultados = res.data
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    abrirCrear () {
      this.editando = false
      this.form = Object.assign({}, this.defaultForm)
      this.dialog = true
    },
    abrirEditar (item) {
      this.editando = true
      this.form = Object.assign({}, item)
      this.dialog = true
    },
    guardar () {
      if (!this.form.nombre || !this.form.codigo) {
        this.$swal.fire('Error', 'Nombre y código son obligatorios.', 'error')
        return
      }
      this.guardando = true
      const req = this.editando ? Api.put('quiniela/equipos', this.form) : Api.post('quiniela/equipos', this.form)
      req.then(() => {
        this.dialog = false
        this.guardando = false
        this.$swal.fire('Listo', this.editando ? 'Equipo actualizado.' : 'Equipo creado.', 'success')
        this.initialize()
      }).catch(() => {
        this.guardando = false
        this.$swal.fire('Error', 'No se pudo guardar el equipo.', 'error')
      })
    },
    async abrirImportar () {
      this.dialogImportar = true
      this.loadingAPI = true
      this.equiposSeleccionados = []
      this.equiposAPI = []
      try {
        const res = await Api.get('quiniela/equipos/fetch-api')
        const existentes = this.resultados.map(e => e.codigo)
        this.equiposAPI = (res.data.teams || []).map(t => ({
          ...t,
          yaExiste: existentes.includes(t.fifa_code)
        }))
        this.equiposSeleccionados = this.equiposAPI
          .filter(t => !t.yaExiste)
          .map(t => t.fifa_code)
      } catch (e) {
        this.$swal.fire('Error', 'No se pudo conectar con la API del Mundial.', 'error')
        this.dialogImportar = false
      }
      this.loadingAPI = false
    },
    seleccionarTodos () {
      this.equiposSeleccionados = this.equiposAPI.map(t => t.fifa_code)
    },
    toggleSeleccion (code) {
      const idx = this.equiposSeleccionados.indexOf(code)
      if (idx >= 0) this.equiposSeleccionados.splice(idx, 1)
      else this.equiposSeleccionados.push(code)
    },
    async confirmarImportar () {
      const aImportar = this.equiposAPI.filter(t => this.equiposSeleccionados.includes(t.fifa_code))
      this.guardandoImport = true
      let ok = 0
      let err = 0
      for (const t of aImportar) {
        const payload = {
          codigo: t.fifa_code,
          nombre: t.name_en,
          bandera_url: t.flag,
          grupo: t.groups,
          activo: true
        }
        try {
          if (t.yaExiste) {
            const eq = this.resultados.find(e => e.codigo === t.fifa_code)
            await Api.put('quiniela/equipos', { ...payload, _id: eq._id })
          } else {
            await Api.post('quiniela/equipos', payload)
          }
          ok++
        } catch (e) { err++ }
      }
      this.guardandoImport = false
      this.dialogImportar = false
      this.initialize()
      this.$swal.fire(
        'Importación completa',
        ok + ' equipo(s) importados.' + (err > 0 ? ' ' + err + ' fallaron.' : ''),
        err > 0 ? 'warning' : 'success'
      )
    },
    eliminar (id) {
      this.$swal.fire({
        title: '¿Eliminar equipo?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then(result => {
        if (result.isConfirmed) {
          this.dialog4 = true
          Api.delete('quiniela/equipos/' + id).then(() => {
            this.dialog4 = false
            this.$swal.fire('Eliminado', 'Equipo eliminado.', 'success')
            this.initialize()
          }).catch(() => {
            this.dialog4 = false
            this.$swal.fire('Error', 'No se pudo eliminar.', 'error')
          })
        }
      })
    }
  }
}
</script>
